import { createSlice } from '@reduxjs/toolkit'

import { channelState } from './channel.type'

const initialState: channelState = {
  pinList: typeof window === 'undefined' ? '' : localStorage.getItem('pinList') || '',
}

const channelSlice = createSlice({
  name: 'channel',
  initialState,
  reducers: {
    setListPin: (state, action) => {
      localStorage.setItem('pinList', action.payload)
      state.pinList = action.payload
    },
  },
  extraReducers: () => {},
})

export const channelActions = channelSlice.actions
const channelReducer = channelSlice.reducer
export default channelReducer
